import * as React from "react"
const DocFileIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={40}
    fill="none"
    {...props}
  >
    <path
      stroke="#338AFF"
      strokeWidth={2}
      d="m1.595 10.357 8.898-8.78A2 2 0 0 1 11.898 1H28a3 3 0 0 1 3 3v32a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V11.78a2 2 0 0 1 .595-1.423Z"
    />
    <path stroke="#338AFF" strokeWidth={2} d="M11 2v9a1 1 0 0 1-1 1H2" />
    <path
      fill="#338AFF"
      d="M20.994 32H18.14l-1.624-6.399c-.056-.231-.14-.62-.252-1.167l-.122-.613c-.085-.44-.135-.751-.151-.932l-.028.215c-.034.24-.088.553-.162.94l-.156.784c-.072.351-.132.625-.18.822L13.859 32h-2.845L8 20h2.465l1.51 6.55c.265 1.21.456 2.257.575 3.144.03-.288.095-.722.196-1.301l.026-.148c.115-.654.225-1.162.327-1.523L14.82 20h2.368l1.721 6.722.036.15c.069.296.151.706.247 1.23l.071.398c.079.451.141.849.188 1.194l.036-.27c.053-.374.127-.817.222-1.327l.095-.494c.082-.416.158-.767.228-1.053L21.535 20H24l-3.006 12Z"
    />
  </svg>
)
export default DocFileIcon
